<template>

<div class="font_preload" style="opacity: 0; height: 0px;">
    <!-- Headline Sans -->
<span style="font-family: 'NPO Nova Sans Headline Black';"></span>
<span style="font-family: 'NPO Nova Sans Headline Black Oblique';"></span>
<span style="font-family: 'NPO Nova Sans Headline Bold';"></span>
<span style="font-family: 'NPO Nova Sans Headline Bold Oblique';"></span>
<span style="font-family: 'NPO Nova Sans Headline Light';"></span>
<span style="font-family: 'NPO Nova Sans Headline Light Oblique';"></span>
<span style="font-family: 'NPO Nova Sans Headline Medium';"></span>
<span style="font-family: 'NPO Nova Sans Headline Medium Oblique';"></span>
<span style="font-family: 'NPO Nova Sans Headline Regular';"></span>
<span style="font-family: 'NPO Nova Sans Headline Regular Oblique';"></span>

<!-- Text Sans -->
<span style="font-family: 'NPO Nova Sans Text Black';"></span>
<span style="font-family: 'NPO Nova Sans Text Black Oblique';"></span>
<span style="font-family: 'NPO Nova Sans Text Bold';"></span>
<span style="font-family: 'NPO Nova Sans Text Bold Oblique';"></span>
<span style="font-family: 'NPO Nova Sans Text Light';"></span>
<span style="font-family: 'NPO Nova Sans Text Light Oblique';"></span>
<span style="font-family: 'NPO Nova Sans Text Medium';"></span>
<span style="font-family: 'NPO Nova Sans Text Medium Oblique';"></span>
<span style="font-family: 'NPO Nova Sans Text Regular';"></span>
<span style="font-family: 'NPO Nova Sans Text Regular Oblique';"></span>

<!-- Condensed Sans -->
<span style="font-family: 'NPO Nova Sans Condensed Bold';"></span>
<span style="font-family: 'NPO Nova Sans Condensed Bold Oblique';"></span>
<span style="font-family: 'NPO Nova Sans Condensed Regular';"></span>
<span style="font-family: 'NPO Nova Sans Condensed Oblique';"></span>

<!-- Text Serif -->
<span style="font-family: 'NPO Nova Serif Text Black';"></span>
<span style="font-family: 'NPO Nova Serif Text Black Italic';"></span>
<span style="font-family: 'NPO Nova Serif Text Bold';"></span>
<span style="font-family: 'NPO Nova Serif Text Bold Italic';"></span>
<span style="font-family: 'NPO Nova Serif Text Light';"></span>
<span style="font-family: 'NPO Nova Serif Text Light Italic';"></span>
<span style="font-family: 'NPO Nova Serif Text Medium';"></span>
<span style="font-family: 'NPO Nova Serif Text Medium Italic';"></span>
<span style="font-family: 'NPO Nova Serif Text Regular';"></span>
<span style="font-family: 'NPO Nova Serif Text Regular Italic';"></span>

<!-- Headline Serif -->
<span style="font-family: 'NPO Nova Serif Headline Black';"></span>
<span style="font-family: 'NPO Nova Serif Headline Black Italic';"></span>
<span style="font-family: 'NPO Nova Serif Headline Bold';"></span>
<span style="font-family: 'NPO Nova Serif Headline Bold Italic';"></span>
<span style="font-family: 'NPO Nova Serif Headline Light';"></span>
<span style="font-family: 'NPO Nova Serif Headline Light Italic';"></span>
<span style="font-family: 'NPO Nova Serif Headline Medium Italic';"></span>
<span style="font-family: 'NPO Nova Serif Headline Regular';"></span>
<span style="font-family: 'NPO Nova Serif Headline Regular Italic';"></span>

</div>

	<div ref="glyphBlockContainer" :class="`glyph-block-container ${fonts} site-margin`">
	  <div ref="glyphBlockLeft" class="glyph-block-left">
		
		<div class="glyph-block-left-dropdowns">
			<h5>Glyphs</h5>
			<select name="selectFontFamily" id="selectFontFamily" v-model="selectedFamily" v-if="selectFontFamily.length > 1 && selectedFont == 'NPO'" @change="onChangeFamily()">
				<option v-for="(fontfamily, index) in selectFontFamily"
					:value="fontfamily.name"
					:key="fontfamily.name"
					:selected="index === 1"
				>
					{{ fontfamily.name }}
				</option>
			</select>
			<select name="selectFontStyle" id="selectFontStyle" v-model="selectedStyle" v-if="selectFontStyles.length > 1 && selectedFont == 'NPO'"   @change="onChangeStyle()">
				<option v-for="(fontstyle, index) in selectFontStyles"
					:value="fontstyle.fontfaceName"
					:key="fontstyle.fontfaceName"
					:selected="index === 1"
				>
					{{ fontstyle.styleName }}
				</option>
			</select>
			<input type="range" class="styled-slider slider-progress" :id="`font-variable-slider-${id}`" :min="100" :max="900" :step="100" v-model="weight" :value="500" v-if="selectedFont == 'Canal'" @change="onSliderChange(weight)"/>
		</div>
		<div class="glyph-block-left-render">
			<div ref="glyphLeftChar" id="glyph-left" class="glyph-block-left-char">A</div>
			
			<div class="glyph-block-stats" ref="glyphBlockStats">
				<!-- <div class="glyph-block-stats-ascender">
					<span class="glyph-block-stats-text">Ascender</span>
					<span class="glyph-block-stats-line"></span>
				</div> -->
				<div class="glyph-block-stats-capHeight glyph-block-stats-container">
					<span class="glyph-block-stats-text">Cap height</span>
					<span class="glyph-block-stats-line"></span>
				</div>
				<div class="glyph-block-stats-xHeight glyph-block-stats-container">
					<span class="glyph-block-stats-text">X-height</span>
					<span class="glyph-block-stats-line"></span>
				</div>
				<div class="glyph-block-stats-baseline glyph-block-stats-container">
					<span class="glyph-block-stats-text">Baseline</span>
					<span class="glyph-block-stats-line"></span>
				</div>
				<div class="glyph-block-stats-descent glyph-block-stats-container">
					<span class="glyph-block-stats-text">Descender</span>
					<span class="glyph-block-stats-line"></span>
				</div>
			</div>
		</div>
		
		
	  </div>
	  
	  <div class="glyph-block-left-mobile-gradient"></div>
	  <div class="glyph-block-right-mobile-gradient"></div>
	  <div class="glyph-block-right" ref="glyphBlockRight">
		<CharacterBlock title="Uppercase" :characters="upperCase" @char-selected="ChangeLetter" />
		<CharacterBlock v-if="showLowercase" title="Lowercase" :characters="lowerCase" @char-selected="ChangeLetter" />
		<CharacterBlock title="Numbers" :characters="numbers" @char-selected="ChangeLetter" />
		<CharacterBlock title="Punctuation and symbols" :characters="symbols" @char-selected="ChangeLetter" />		
	  </div>
	</div>
  </template>
  
  <script setup>
 import { ref, computed, onMounted, onUnmounted } from 'vue';
import * as fontkit from 'fontkit';
import CharacterBlock from './CharacterBlock.vue';

const props = defineProps({
  fonts: String,
});

const glyphBlockContainer = ref(null);
const glyphBlockLeft = ref(null);
const glyphLeftChar = ref(null);
const glyphBlockRight = ref(null);
const glyphBlockStats = ref(null);

const lowerCase = ref([...Array(26)].map((_, i) => String.fromCharCode(i + 97)));
const upperCase = ref([...Array(26)].map((_, i) => String.fromCharCode(i + 65)));
const numbers = ref(["1","2","3","4","5","6","7","8","9","0"]);
const symbols = ref([]);
const showLowercase = ref(true);

const gridRows = ref([]);
let baseFontSize = 400;
const baseMobileWindowWidth = 767;
const baseWindowWidth = 1600;

const selectedFamily = ref("");
const selectedStyle = ref("");
const selectedFont = ref("");

const selectFontFamily = ref([]);
const selectFontStyles = ref([]);

const fontOffsetNoSupport = ref(0); 

const isIOSDevice = ref(false);

const fontlist = [
	{ font: "Benromach", 
		location: "/media/m3efilgx/benromach-regular.otf", 
		symbols: ["*","!","\"","£","$","%","^","&","*","(",")","-","+","=", "'"],
    showLowercase: true, 
		fontFamilies: [{name: "a", styles: [{styleName: "Medium", fontfaceName: "Benromach OTF"}]}],
		marginOffset: -2.25,
		marginOffsetIOS: -2.25,
	},
	{ font: "NPO", 
		location: "/media/ip3footo/nponovaserifheadline-medium.otf", 
		symbols: ["*","!","\"","£","$","%","^","&","*","(",")","-","+","=", "'"], 
    showLowercase: true,
		fontFamilies: [{
						name: "NPO Nova Sans Headline", styles: [
							{styleName: "Light", fontfaceName: "NPO Nova Sans Headline Light OTF"},
							{styleName: "Light Oblique", fontfaceName: "NPO Nova Sans Headline Light Oblique OTF"},
							{styleName: "Medium", fontfaceName: "NPO Nova Sans Headline Medium OTF"},
							{styleName: "Medium Oblique", fontfaceName: "NPO Nova Sans Headline Medium Oblique OTF"},
							{styleName: "Regular", fontfaceName: "NPO Nova Sans Headline Regular OTF"},
							{styleName: "Regular Oblique", fontfaceName: "NPO Nova Sans Headline Regular Oblique OTF"},
							{styleName: "Bold", fontfaceName: "NPO Nova Sans Headline Bold OTF"},
							{styleName: "Bold Oblique", fontfaceName: "NPO Nova Sans Headline Bold Oblique OTF"},
							{styleName: "Black", fontfaceName: "NPO Nova Sans Headline Black OTF"},
							{styleName: "Black Oblique", fontfaceName: "NPO Nova Sans Headline Black Oblique OTF"},
						]},
						{name: "NPO Nova Sans Text", styles: [
							{styleName: "Light", fontfaceName: "NPO Nova Sans Text Light"},
							{styleName: "Light Oblique", fontfaceName: "NPO Nova Sans Text Light Oblique"},
							{styleName: "Medium", fontfaceName: "NPO Nova Sans Text Medium"},
							{styleName: "Medium Oblique", fontfaceName: "NPO Nova Sans Text Medium Oblique"},
							{styleName: "Regular", fontfaceName: "NPO Nova Sans Headline Regular"},
							{styleName: "Regular Oblique", fontfaceName: "NPO Nova Sans Headline Regular Oblique"},
							{styleName: "Bold", fontfaceName: "NPO Nova Sans Text Bold"},
							{styleName: "Bold Oblique", fontfaceName: "NPO Nova Sans Text Bold Oblique"},
							{styleName: "Black", fontfaceName: "NPO Nova Sans Text Black"},
							{styleName: "Black Oblique", fontfaceName: "NPO Nova Sans Text Black Oblique"},
						]},
						{name: "NPO Nova Sans Condensed", styles: [							
							{styleName: "Regular", fontfaceName: "NPO Nova Sans Condensed Regular"},
							{styleName: "Oblique", fontfaceName: "NPO Nova Sans Condensed Oblique"},
							{styleName: "Bold", fontfaceName: "NPO Nova Sans Condensed Bold"},
							{styleName: "Bold Oblique", fontfaceName: "NPO Nova Sans Condensed Bold Oblique"},							
						]},
						{name: "NPO Nova Serif Headline", styles: [
							{styleName: "Light", fontfaceName: "NPO Nova Serif Headline Light"},
							{styleName: "Light Italic", fontfaceName: "NPO Nova Serif Headline Light Italic"},
							{styleName: "Medium", fontfaceName: "NPO Nova Serif Headline Medium OTF"},
							{styleName: "Medium Italic", fontfaceName: "NPO Nova Serif Headline Medium Italic"},
							{styleName: "Regular", fontfaceName: "NPO Nova Serif Headline Regular"},
							{styleName: "Regular Italic", fontfaceName: "NPO Nova Serif Headline Regular Italic"},
							{styleName: "Bold", fontfaceName: "NPO Nova Serif Headline Bold"},
							{styleName: "Bold Italic", fontfaceName: "NPO Nova Serif Headline Bold Italic"},
							{styleName: "Black", fontfaceName: "NPO Nova Serif Headline Black"},
							{styleName: "Black Italic", fontfaceName: "NPO Nova Serif Headline Black Italic"},
						]},
						{name: "NPO Nova Serif Text", styles: [
							{styleName: "Light", fontfaceName: "NPO Nova Serif Text Light"},
							{styleName: "Light Italic", fontfaceName: "NPO Nova Serif Text Light Italic"},
							{styleName: "Medium Italic", fontfaceName: "NPO Nova Serif Text Medium Italic"},
							{styleName: "Regular", fontfaceName: "NPO Nova Serif Headline Regular"},
							{styleName: "Regular Italic", fontfaceName: "NPO Nova Sans Headline Regular Italic"},
							{styleName: "Bold", fontfaceName: "NPO Nova Serif Text Bold"},
							{styleName: "Bold Italic", fontfaceName: "NPO Nova Serif Text Bold Italic"},
							{styleName: "Black", fontfaceName: "NPO Nova Serif Text Black"},
							{styleName: "Black Italic", fontfaceName: "NPO Nova Serif Text Black Italic"},
						]},
						
					],
					marginOffset: 0,
					marginOffsetIOS: -2.5,
				
	},
	{ font: "Canal", 
		location: "/media/xsdjevoj/canaldopplervariablevf.otf", 
		symbols: ["!","\"","-","'"],
    	showLowercase: false,
		fontFamilies: [{name: "a", styles: [{styleName: "Bold", fontfaceName: "Canal"}]}],
		marginOffset: 1.2,
		marginOffsetIOS: 1.2,
	},
	{ font: "Walkers",
		location: "/media/eg2jm1ul/aberlour-regular.otf", 
		symbols: ["*","!","\"","£","$","%","^","&","*","(",")","-","+","=", "'"],
    showLowercase: true,
		fontFamilies: [{name: "a", styles: [{styleName: "Medium", fontfaceName: "Aberlour"}]}],
		marginOffset: -1.3,
		marginOffsetIOS: -1.3,
	}
  ];

  

const currentFont = computed(() => fontlist.find(f => f.font === props.fonts) || {});


function isIOS() {
	try {
		if (typeof navigator === 'undefined' || typeof window === 'undefined') {
			console.log('Not in a browser environment');
			return false;
		}

		const userAgent = navigator.userAgent || '';
		const maxTouchPoints = navigator.maxTouchPoints || 0;

		// console.log('User Agent:', userAgent);
		// console.log('Max Touch Points:', maxTouchPoints);

		// 1. Classic iOS detection (mostly for older Safari or real devices)
		const iOSMatch = /iPhone|iPad|iPod/.test(userAgent);
		// console.log('iOS Match from userAgent:', iOSMatch);

		// 2. iPadOS detection: Desktop UA but touch support
		const isMacLikeTouchDevice = userAgent.includes('Macintosh') && maxTouchPoints > 1;
		// console.log('Is Mac-like Touch Device (iPadOS desktop mode):', isMacLikeTouchDevice);

		// 3. WebKit with no Chrome (Safari-only detection)
		const isWebKit = /AppleWebKit/.test(userAgent);
		const isChrome = /CriOS|Chrome/.test(userAgent);
		const isSafari = isWebKit && !isChrome;
		// console.log('Is WebKit:', isWebKit);
		// console.log('Is Chrome (including CriOS):', isChrome);
		// console.log('Is Safari:', isSafari);

		if(isSafari) return true;
		// 4. Likely iOS (heuristic): WebKit + touch + small screen
		const isLikelyIOS = isSafari && maxTouchPoints > 1 && screen.width <= 1024;
		// console.log('Is Likely iOS (heuristic):', isLikelyIOS);

		// 5. Web App (PWA) standalone mode
		const isStandalone = window.navigator.standalone === true;
		// console.log('Is Standalone Web App (PWA):', isStandalone);

		// 6. Fallback: custom class applied externally
		const iosClassEl = typeof document !== 'undefined' && document.querySelector('.ios-device');
		// console.log('DOM element with .ios-device class exists:', !!iosClassEl);

		const result = !!(iOSMatch || isMacLikeTouchDevice || isLikelyIOS || isStandalone || iosClassEl);
		// console.log('Final iOS Detection Result:', result);
		return result;
	} catch (e) {
		console.error('Error during iOS detection:', e);
		return false;
	}
}

const resizeLeftPanel = () => {
  if (!glyphLeftChar.value || !glyphBlockLeft.value) return;  
	// console.log(glyphLeftChar.value)
  const windowSize = window.innerWidth;

  if(windowSize < baseMobileWindowWidth){
    const ratio = windowSize / (baseMobileWindowWidth + 200);
    glyphLeftChar.value.style.fontSize = `${baseFontSize * ratio}px`;
    glyphBlockStats.value.style.setProperty('--gridRows', resizeGridRows(gridRows.value, ratio));
	if (glyphLeftChar.value) {
		glyphLeftChar.value.style.transform = `translateY(${fontOffsetNoSupport.value * ratio}rem)`;
	}
	
  }
  else if (windowSize < baseWindowWidth) {
    const ratio = windowSize / baseWindowWidth;
    glyphLeftChar.value.style.fontSize = `${baseFontSize * ratio}px`;
    glyphBlockStats.value.style.setProperty('--gridRows', resizeGridRows(gridRows.value, ratio));
	if (glyphLeftChar.value) {
		glyphLeftChar.value.style.transform = `translateY(${fontOffsetNoSupport.value * ratio}rem)`;
	}
  } else {
    glyphLeftChar.value.style.fontSize = `${baseFontSize}px`;
    glyphBlockStats.value.style.setProperty('--gridRows', resizeGridRows(gridRows.value, 1));
	if (glyphLeftChar.value) {
		glyphLeftChar.value.style.transform = `translateY(${fontOffsetNoSupport.value}rem)`;
	}
  }

  
};

const resizeGridRows = (rows, ratio) => {
  return rows.map(item => `${parseFloat(item) * ratio}px`).join(" ");
};

onMounted(() => {
	

	isIOSDevice.value = isIOS();


	function supportsTextBoxProperties() {
		return CSS.supports("text-box-edge", "cap alphabetic") && CSS.supports("text-box-trim", "trim-both");
	}

	if (currentFont.value.symbols) {
		symbols.value = currentFont.value.symbols;
		selectedFont.value = currentFont.value.font;
		selectFontFamily.value = currentFont.value.fontFamilies;
		selectedFamily.value = currentFont.value.fontFamilies[0].name;
		selectFontStyles.value = currentFont.value.fontFamilies[0].styles;
		selectedStyle.value = currentFont.value.fontFamilies[0].styles[0].fontfaceName;
		showLowercase.value = currentFont.value.showLowercase;
		glyphBlockContainer.value.style.setProperty('--fontFamily', selectedStyle.value);

		console.log('isIos:, ' + isIOSDevice.value)

		if ((currentFont.value.marginOffset !== undefined && !supportsTextBoxProperties() && !isIOSDevice.value)) {
			fontOffsetNoSupport.value = currentFont.value.marginOffset;
		}
		if ((currentFont.value.marginOffsetIOS !== undefined && isIOSDevice.value)) {
			fontOffsetNoSupport.value = currentFont.value.marginOffsetIOS;
		}

		if (!glyphLeftChar.value || !glyphBlockStats.value) return;
		const computedBlockLeft = window.getComputedStyle(glyphBlockStats.value);
		gridRows.value = computedBlockLeft.getPropertyValue("grid-template-rows").split(" ");

		resizeLeftPanel(); 
		window.addEventListener('resize', resizeLeftPanel);
	}

	if (supportsTextBoxProperties() && !isIOSDevice.value) {
		if (glyphLeftChar.value) {
			glyphLeftChar.value.classList.add('supported');
		}
	} else {
		if (glyphLeftChar.value) {
			glyphLeftChar.value.classList.add('ios-text-box-unsupported');
		}
	}
});


onUnmounted(() => {
  window.removeEventListener('resize', resizeLeftPanel);
});

function onChangeFamily() {		
		currentFont.value.fontFamilies.forEach(family => {
			if(family.name == selectedFamily.value){
				selectFontStyles.value = family.styles;
			}
		});
		selectedStyle.value = selectFontStyles.value[0].fontfaceName;

		glyphBlockContainer.value.style.setProperty('--fontFamily', selectedStyle.value)
	}


	function onChangeStyle() {	
		glyphBlockContainer.value.style.setProperty('--fontFamily', selectedStyle.value)
	}

	function onSliderChange(weight){
		glyphLeftChar.value.style.fontWeight = weight
		glyphBlockRight.value.style.fontWeight = weight
	};


const ChangeLetter = (char) => {
  if (char) {
    glyphLeftChar.value.innerHTML = char;		
    loadFont();
  }
};

const loadFont = async () => {
  if (!currentFont.value.location) return;

  const response = await fetch(window.location.origin + currentFont.value.location);
  const arrayBuffer = await response.arrayBuffer();
  const buf = new Uint8Array(arrayBuffer);
  const font = fontkit.create(buf);

//   console.table([
//     ["Units per em", font.unitsPerEm],
//     ["x-height", font.xHeight],
//     ["bbox", font.bbox],
//     ["marginOffset", font.marginOffset],
//     ["descent", font.descent],
//     ["lineGap", font.lineGap],
//     ["capHeight", font.capHeight]
//   ]);
};

  </script>